<template>
  <div class="l_loading">
    <div class="l_loading__animation">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CLoading'
}
</script>

<style scoped>
.l_loading {
  position: absolute;
  top: 0;
  left: 0;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.9);
}

.l_loading__animation {
  height: 40px;
  width: 40px;
  background: transparent;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  border-top-color: #efb80c;
  animation: spinner 600ms linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
</style>
